// extracted by mini-css-extract-plugin
export default {"contextual-menu-item-container":"ContextualMenuItem_contextual-menu-item-container__Ce2nP","variant-red":"ContextualMenuItem_variant-red__jnSx7"};